import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { SharedNote } from './share/SharedNote.tsx';
import { tokenAt } from './share/share-path.ts';
import { startAppearance } from './shell/theme.ts';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

// The look is already on the document - the pre-paint script in index.html put
// it there before any of this was fetched. This is what keeps it there: while
// the choice is `system`, the page follows the device when the device changes
// its mind, which on macOS and iOS happens on its own at sunset. Outside React
// because it belongs to the document rather than to any screen, and never
// stopped because the app ending is the only thing that would stop it.
//
// IT RUNS FOR A SHARED NOTE TOO. That page is read by somebody who has never
// used Perfect Note, so it lands on the default theme and on whatever their
// device says about light and dark - which is exactly right, and is why the
// appearance is per-browser rather than per-account (AGENTS.md).
startAppearance();

/**
 * WHICH APPLICATION THIS IS - and it is decided here, above `App`, rather than
 * in `shell/screens.ts` with the screens.
 *
 * A shared note is not a screen of this application: it is read by somebody with
 * no session, who is not being asked to get one. Mounting it inside the shell
 * would mean `useDayScreen` firing `GET /days/today` on their behalf, taking a
 * 401 and replacing the note they followed a link to with a sign-in gate - so
 * the shell is not mounted at all, exactly as the gate and the first-run
 * question replace it rather than sitting inside it.
 *
 * `tokenAt` answers null for every other path in the product, which is what
 * mounts the ordinary application. The path itself is authored by the SERVER and
 * only read here; `share/share-path.ts` carries that reasoning and names the
 * other half of the pair.
 */
const shared = tokenAt(window.location.pathname);

createRoot(root).render(
  <StrictMode>{shared === null ? <App /> : <SharedNote token={shared} />}</StrictMode>,
);
